import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import Login from "@/views/Login.vue";
import Dashboard from "@/views/Dashboard.vue";
import NewAutomation from "@/views/NewAutomation.vue";
import AutomationDetail from "@/views/AutomationDetail.vue";
import AutomationCaptionPrep from "@/views/AutomationCaptionPrep.vue";
import PrivacyPolicy from "@/views/PrivacyPolicy.vue";
import TokenListView from "@/views/TokenListView.vue";
import NewToken from "@/views/NewToken.vue";
import UserList from "@/views/Users/UserList.vue";
import NewUser from "@/views/Users/NewUser.vue";
import DashboardNew from "@/views/DashboardNewPC.vue";
import NewDashboard from "@/views/NewDashboard.vue";
import BulkDeleteList from "@/views/BulkDeleteList.vue";
import NewBulkDelete from "@/views/NewBulkDelete.vue";
import BulkDeleteDetail from "@/views/BulkDeleteDetail.vue";
import axios from "axios";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    { path: "/login", component: Login, meta: { guest: true } },
    {
      path: "/dashboard",
      component: NewDashboard,
      meta: { requiresAuth: true },
    },
    { path: "/jobs/all", component: Dashboard, meta: { requiresAuth: true } },
    { path: "/tokens", component: TokenListView, meta: { requiresAuth: true } },
    { path: "/new-token", component: NewToken, meta: { requiresAuth: true } },
    {
      path: "/users/all",
      component: UserList,
      meta: { requiresAuth: true, requiresRoot: true },
    },
    {
      path: "/users/new",
      component: NewUser,
      meta: { requiresAuth: true, requiresRoot: true },
    },
    {
      path: "/privacy-policy",
      component: PrivacyPolicy,
      meta: { requiresAuth: false },
    },
    {
      path: "/new-automation",
      component: NewAutomation,
      meta: { requiresAuth: true },
    },
    {
      path: "/automation-detail/:id",
      name: "AutomationDetail",
      component: AutomationDetail,
      meta: { requiresAuth: true },
    },
    {
      path: "/automation-detail/:id/captions",
      name: "AutomationCaptionPrep",
      component: AutomationCaptionPrep,
      meta: { requiresAuth: true },
    },
    {
      path: "/bulk-delete/list",
      component: BulkDeleteList,
      meta: { requiresAuth: true },
    },
    {
      path: "/bulk-delete/new",
      component: NewBulkDelete,
      meta: { requiresAuth: true },
    },
    {
      path: "/bulk-delete/:jobId",
      name: "BulkDeleteDetail",
      component: BulkDeleteDetail,
      meta: { requiresAuth: true },
    },
    // {
    //   path: "/dashboard-new-pc",
    //   component: DashboardNew,
    //   meta: { requiresAuth: true },
    // },
  ],
});

router.beforeEach(async (to, from, next) => {
  const isAuthenticated = store.getters.isAuthenticated;
  const isRootUser = store.getters.isRootUser;

  // Check token validity if user is authenticated
  if (isAuthenticated) {
    try {
      // Add request interceptor to catch 401 errors
      axios.interceptors.response.use(
        (response) => response,
        (error) => {
          if (
            error.response &&
            (error.response.status === 401 || error.response.status === 403)
          ) {
            store.dispatch("logout");
            router.push("/login");
          }
          return Promise.reject(error);
        },
      );
    } catch (error) {
      // If any error occurs during validation, logout user
      store.dispatch("logout");
      return next("/login");
    }
  }

  if (to.meta.requiresAuth && !isAuthenticated) {
    return next("/login"); // Redirect to login if not authenticated
  }

  if (to.meta.requiresRoot && !isRootUser) {
    return next("/dashboard"); // Redirect non-root users to home/dashboard
  }

  if (to.fullPath === "/") {
    return next("/dashboard");
  }
  next(); // Proceed to the route
});

export default router;
